import ClientsContainer from './ClientsContainer';

export default ClientsContainer;
